export default {
  PUBLISHER: "publisher",
  POSITION: "position",
  TIME: "time",
};
